import WarpElement from '@warp-ds/elements-core';
import { html, css } from 'lit';
import pulse from '@finn-no/pulse-sdk';

class RealestateLettingsPopular extends WarpElement {
    static properties = {
        items: {
            type: Array,
            converter: {
                fromAttribute: (value) => {
                    try {
                        return JSON.parse(value);
                    } catch (e) {

                        return []; // Return an empty array in case of error
                    }
                },
                toAttribute: (value) => JSON.stringify(value)
            }
        }
    }

    static styles = [
        WarpElement.styles,
        css`
            *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0;box-sizing:border-box;border-style:solid;border-width:0;border-color:var(--w-s-color-border,var(--w-s-color-border-default))}html{font-size:62.5%}body{background-color:var(--w-s-color-background,var(--w-s-color-background-default));min-height:100%;margin:0;overflow-y:scroll}body,:host{-webkit-text-size-adjust:100%;tab-size:4;-webkit-tap-highlight-color:transparent;font-family:var(--w-font-family);font-size:var(--w-font-size-m);line-height:var(--w-line-height-m);color:var(--w-s-color-text,var(--w-s-color-text-default))}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:700}a{cursor:pointer;color:var(--w-s-color-text-link);text-decoration:none}a:hover,a:focus,a:active{-webkit-text-decoration:var(--w-decoration-text-link);-webkit-text-decoration:var(--w-decoration-text-link);text-decoration:var(--w-decoration-text-link)}b,strong{font-weight:700}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:var(--w-s-color-text-placeholder)}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}h1{font-size:var(--w-font-size-xxl);line-height:var(--w-line-height-xxl)}h2{font-size:var(--w-font-size-xl);line-height:var(--w-line-height-xl)}h3{font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}h4{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}h5{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}dt,dd{margin:0 16px}h1,h2,h3,h4,h5,ul,ol,dl,p,blockquote{margin:0 0 8px}[hidden]{display:none!important}[tabindex="-1"]:focus:not(:focus-visible){outline:none}legend{float:left;width:100%;margin:0;padding:0;display:table}legend+*{clear:both}fieldset{border:0;min-width:0;margin:0;padding:.01em 0 0}body:not(:-moz-handler-blocked) fieldset{display:table-cell}.aspect-3\\/2{padding-bottom:66.6667%;position:relative}.aspect-3\\/2>*{width:100%;height:100%;position:absolute;top:0;bottom:0;left:0;right:0}.border-2{border-width:2px}.border-transparent{border-color:#0000}.rounded-8{border-radius:8px}.block{display:block}.flex{display:flex}.hover\\:no-underline:hover{text-decoration:none}.gap-16{gap:1.6rem}.col-span-1{grid-column:span 1/span 1}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.overflow-hidden{overflow:hidden}.overflow-scroll{overflow:scroll}.outline-none{outline-offset:2px;outline:2px solid #0000}.outline{outline-style:solid}.inset-0{top:0;bottom:0;left:0;right:0}.absolute{position:absolute}.relative{position:relative}.static{position:static}.z-10{z-index:10}.s-text-inverted{color:var(--w-s-color-text-inverted)}.h-full{height:100%}.w-full{width:100%}.mb-16{margin-bottom:1.6rem}.mt-auto{margin-top:auto}.py-10{padding-top:1rem;padding-bottom:1rem}.pl-10{padding-left:1rem}.pr-16{padding-right:1.6rem}.font-bold{font-weight:700}.object-cover{object-fit:cover}.object-center{object-position:center}.pointer-events-none{pointer-events:none}.transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}@media (min-width:768px){.md\\:grid{display:grid}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (min-width:990px){.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}};

            :host {
                display: block;
            }

            .swipe-container {
                scroll-snap-type: x mandatory;
                margin-left: -16px;
                margin-right: -16px;
            }
            @media (min-width: 768px) {
                .swipe-container {
                    margin-left: 0px;
                    margin-right: 0px;
                }
            }
            .swipe-item {
                scroll-snap-align: center;
                width: min(calc(100vw - 70px), 343px);
                flex-shrink: 0;
            }
            .swipe-item:first-child {
                margin-left: 16px;
            }

            @media (min-width: 768px) {
                .swipe-item {
                    width: 100%;
                }
                .swipe-item:first-child {
                    margin-left: 0px;
                }
            }

            .hide-scroll {
                scrollbar-width: none;
                -ms-overflow-style: none;
            }

            .hide-scroll::-webkit-scrollbar {
                width: 0 !important;
                display: none;
            }

            @supports selector(:has(a, b)) {
                /*
                Show focus outline around the entire card, instead of the standard outline
                just around the link, for browsers that support the :has() selector.
                */
                .swipe-item:has(.swipe-item-link:focus-visible) > .swipe-item-outline {
                    border-color: var(--w-s-color-border-selected);
                }

                .swipe-item-link {
                    &:focus {
                        text-decoration: none;
                    }

                    &:focus-visible {
                        outline: none;
                    }
                }
            }
            `,
    ];

    constructor() {
        super();
        this.items = [];
    }

    renderItem(item) {
        return html`
            <div class="aspect-3/2 overflow-hidden rounded-8 col-span-1 relative swipe-item">
                <img alt="" class="w-full h-full object-center object-cover rounded-8" src=${item.img} style="max-width: 100%; max-height: 100%;">
                <div class="absolute inset-0 flex">
                    <div class="mt-auto font-bold s-text-inverted py-10 pl-10 pr-16" style="background: linear-gradient(transparent, rgba(0, 0, 0, 0.05) 13.71%, rgba(0, 0, 0, 0.114) 25.12%, rgba(0, 0, 0, 0.192) 34.61%, rgba(0, 0, 0, 0.28) 42.59%, rgba(0, 0, 0, 0.37) 49.46%, rgba(0, 0, 0, 0.46) 55.63%, rgba(0, 0, 0, 0.55) 61.47%, rgba(0, 0, 0, 0.627) 67.41%, rgba(0, 0, 0, 0.698) 73.83%, rgba(0, 0, 0, 0.753) 81.13%, rgba(0, 0, 0, 0.79) 89.73%, rgba(0, 0, 0, 0.8)); width: 100%;">
                        <a href=${item.link} class="col-span-1 s-text-inverted hover:no-underline swipe-item-link" @click=${() => pulse.trackEvent({
            type: 'Click',
            intent: 'Open',
            name: `Go to suggested rental listing in ${item.text}`,
            object: {
                type: 'UIElement',
                elementType: 'Button',
            },
            target: {
                type: 'Listing',
            },
            vertical: {
                name: 'realestate',
            },
        })
            }>
                            <span class="inset-0 absolute" aria-hidden="true"></span>
                            ${item.text}
                        </a>
                    </div>
                </div>
                <div class="rounded-8 swipe-item-outline pointer-events-none absolute inset-0 z-10 border-2 border-transparent outline-none transition-all"></div>
            </div>
        `;
    }

    render() {
        return html`
            <nav aria-labelledby="popular-lettings">
                <h2 id="popular-lettings" class="mb-16">Populære byer å leie i</h2>
                <div class="flex overflow-scroll md:overflow-initial md:grid gap-16 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 swipe-container hide-scroll">
                    ${this.items.map(item => this.renderItem(item))}
                </div>
            </nav>
        `;
    }
}

customElements.define('realestate-lettings-popular', RealestateLettingsPopular);
